import { Box, Switch, Tooltip } from '@material-ui/core';

import { useTranslation } from '@/components/shared/hooks/useTranslation';
import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { Text } from '@/components/shared/components/Text';

interface PricingSpecSearchSwitchProps {
  pricingSpecSearchEnabled: boolean;
  setPricingSpecSearchEnabled: (enabled: boolean) => void;
}

export const PricingSpecSearchSwitch = ({
  pricingSpecSearchEnabled,
  setPricingSpecSearchEnabled,
}: PricingSpecSearchSwitchProps) => {
  const { getTextIdTranslation } = useTranslation();
  return (
    <Box display={'flex'} gridGap={16}>
      <Tooltip title={getTextIdTranslation('PRICING_SPEC_SEARCH_ENABLED_TOOLTIP')}>
        <Box display={'inline-flex'} gridGap={8}>
          <Icon style={{ fontSize: 20 }}>info</Icon>
          <Font variant={'body2'} color={'textSecondary'}>
            <Text tId={'PRICING_SPEC_SEARCH_ENABLED'} />
          </Font>
        </Box>
      </Tooltip>
      <Switch
        checked={pricingSpecSearchEnabled}
        onChange={() => setPricingSpecSearchEnabled(!pricingSpecSearchEnabled)}
        name="pricingSpecSearchEnabledSwitch"
        color="primary"
      />
    </Box>
  );
};
